const buttonsElement = '.js-not-implemented-yet';

const notImplementedYetInit = function() {
    document.querySelectorAll(buttonsElement).forEach((button) => {
        button.addEventListener('mouseenter', (e) => {
            const tooltipExist = e.target.querySelector('.tooltip');
            if (!tooltipExist) {
                e.target.style.position = 'relative';
                e.target.insertAdjacentHTML('beforeend',
                    `<div class="tooltip">Not implemented yet</div>`,
                );
            }
        });

        button.addEventListener('mouseleave', (e) => {
            const tooltip = e.target.querySelector('.tooltip');
            if (tooltip) {
                e.target.style.removeProperty('position');
                tooltip.remove();
            }
        });
    });
};

window.notImplementedYetInit = notImplementedYetInit;

notImplementedYetInit();
